var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React, { useState, useEffect, createContext } from 'react';
import PropTypes from 'prop-types';
import { all, spread } from 'axios';
import { /* find, */camelCase, get } from 'lodash';
import useSession from '../hooks/use-session';
import { authorizedPyInstance as Py } from '../helpers/api';
var transformName = function transformName(item, key) {
  return camelCase(get(item, key));
};
var mapDivisionItem = function mapDivisionItem(divisionItem, key) {
  return _extends({}, divisionItem, {
    name: transformName(divisionItem, key)
  });
};
var mapEvents = function mapEvents(events) {
  return events ? events.map(function (e) {
    return mapDivisionItem(e, 'attributes.eventTypeName');
  }) : [];
};
var mapFeatureFlags = function mapFeatureFlags(featureFlags) {
  return featureFlags ? featureFlags.map(function (f) {
    return mapDivisionItem(f, 'featureFlagName');
  }) : [];
};
var mapDivisionSettings = function mapDivisionSettings(divisionSettings) {
  return divisionSettings ? divisionSettings.map(function (s) {
    return mapDivisionItem(s, 'settingName');
  }) : [];
};
var mapDivisionServices = function mapDivisionServices(divisionServices) {
  return divisionServices ? divisionServices.map(function (s) {
    return mapDivisionItem(s, 'serviceName');
  }) : [];
};
var mapPermissions = function mapPermissions(permissions) {
  return permissions ? permissions.map(function (s) {
    return mapDivisionItem(s, 'securityPermissionName');
  }) : [];
};
var reduceItemByName = function reduceItemByName(a, m) {
  return _extends({}, a, _defineProperty({}, m.name, m));
};
var FlagContext = createContext({});
var FlagProvider = function FlagProvider(_ref) {
  var children = _ref.children;
  var _useSession = useSession(),
    current = _useSession.current;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    features = _useState2[0],
    setFeatures = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    settings = _useState4[0],
    setSettings = _useState4[1];
  useEffect(function () {
    if (current) {
      var _current$attributes = current.attributes,
        permissions = _current$attributes.permissions,
        divisionSettings = _current$attributes.divisionSettings,
        divisionServices = _current$attributes.divisionServices,
        featureFlags = _current$attributes.featureFlags,
        isImpersonated = _current$attributes.isImpersonated;
      var permissionNames = (permissions || []).map(function (p) {
        return p.securityPermissionName;
      });
      var featureFlagNames = (featureFlags || []).map(function (p) {
        return p.featureFlagName;
      });
      var hasDebugMode = {
        hasDebugMode: isImpersonated || permissionNames.includes('canImpersonate') || permissionNames.includes('hasAppDebug') || featureFlagNames.includes('debug_mode')
      };
      setSettings([].concat(_toConsumableArray(mapDivisionServices(divisionServices)), _toConsumableArray(mapDivisionSettings(divisionSettings))).reduce(reduceItemByName, {}));
      if (permissions.map(function (p) {
        return p.securityPermissionName;
      }).includes('hasAppNavigator')) {
        all([Py.get('api/data/reference/reference-event')]).then(spread(function (events) {
          setFeatures([].concat(_toConsumableArray(mapPermissions(permissions)), _toConsumableArray(mapFeatureFlags(featureFlags)), _toConsumableArray(mapEvents(events.data.data))).reduce(reduceItemByName, hasDebugMode));
        }));
      } else {
        setFeatures([].concat(_toConsumableArray(mapPermissions(permissions)), _toConsumableArray(mapFeatureFlags(featureFlags))).reduce(reduceItemByName, hasDebugMode));
      }
    }
  }, [current]);
  return React.createElement(FlagContext.Provider, {
    value: {
      features: features,
      settings: settings
    }
  }, children);
};
FlagProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export { FlagContext, FlagProvider };